package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.roster.ShiftTimeDto
import com.evoapps.evoshift.domain.model.TimeRange

class ShiftTimeMapper {

    fun toDomain(dto: ShiftTimeDto): TimeRange {
        return TimeRange(
            start = dto.start,
            end = dto.end
        )
    }

    fun toDto(domain: TimeRange): ShiftTimeDto {
        return ShiftTimeDto(
            start = domain.start,
            end = domain.end
        )
    }
}
